import {
  Box,
  Center,
} from "@chakra-ui/react";

export default function LineSection() {
  return (
    <Center
      px={5}>
      <Box
        bg={"white"}
        h={"2px"}
        w={"full"}
        maxW={"8xl"}
        borderRadius={50}
      >
      </Box>
    </Center>
  );
}